<template>
  <div class="home-news news-container">
    <!-- <img src="@/views/web/home/imgs/newsBanner.png" style="width: 100%" />-->
    <header class="home-news-hd">
      <div
        class="news-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="news-hd-subTitle">最新动态</h4>
        <h2 class="news-hd-title">了解狄诺尼的最新资讯与活动</h2>
      </div>
    </header>
    <div class="topTitle">
      <div class="flex-row">
        <div style="width: 80px">当前位置：</div>
        <div class="backBtn" @click="back">新闻资讯&nbsp;> &nbsp;</div>
        <el-tooltip :content="news.title" placement="bottom-start">
          <div class="newsTitle">{{ news.title }}</div>
        </el-tooltip>
      </div>
    </div>

    <div class="news">
      <div class="title">{{ news.title }}</div>

      <div class="line"></div>

      <div class="date">发布时间：{{ news.date }}</div>

      <template v-if="news.type == 2">
        <div class="videoBox" v-if="news.videoUrl">
          <video controls :poster="news.coverPicUrl">
            <source :src="news.videoUrl" type="video/mp4" />
          </video>
        </div>
      </template>
      <template v-else>
        <div v-html="news.content" class="content"></div>
      </template>
    </div>
  </div>
</template>

<script>
import { news1, news2, news3 } from "./news";

import { newsDetailApi, tracklogApi } from "@/api/website";
export default {
  name: "newsDetail",
  props: {},
  components: {},
  data() {
    return {
      news: {},
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.id === "1") {
      this.news = news1;
    } else if (this.$route.query.id === "2") {
      this.news = news2;
    } else if (this.$route.query.id === "3") {
      this.news = news3;
    }
    this.getDetail();
  },
  methods: {
    back() {
      let classification = this.$route.query.classification || "0";
      let page = this.$route.query.page || 1;
      this.$uniFun.openInCurrentTab(
        `/pc_index/news?&classification=${classification}&page=${page}`,
      );
    },
    async getDetail() {
      let newsId = this.$route.query.id;
      let params = { id: newsId };
      await newsDetailApi(params).then((res) => {
        if (res.code === 200 && res.success) {
          console.log("newsDetailApi", res);
          this.news = {
            title: res.data.title,
            type: res.data.type,
            date: res.data.effectiveTime.substring(0, 10),
            content: res.data.content,
            videoUrl:
              res.data.videoUrlIdList.length > 0
                ? res.data.videoUrlIdList[0].path
                : "",
            coverPicUrl:
              res.data.coverUrlIdList.length > 0
                ? res.data.coverUrlIdList[0].path
                : "",
          };
          console.log("news", this.news);
          tracklogApi({ module: "3_" + newsId });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/common.scss";
.home-news.news-container {
  background: white;
  padding-bottom: 38px;
  .home-news-hd {
    width: 100%;
    height: 200px;
    background: url("~@/views/web/home/imgs/newsBanner.png") no-repeat center;
    background-size: cover;
    .news-hd-wrapper {
      width: 1200px;
      margin: 0 auto;
      padding-top: 50px;
      .news-hd-subTitle {
        margin-bottom: 20px;
        font-weight: 400;
        font-size: 18px;
        color: #fff;
        line-height: 27px;
        font-style: normal;
      }
      .news-hd-title {
        font-weight: bold;
        font-size: 28px;
        color: #fff;
        line-height: 28px;
        font-style: normal;
      }
    }
  }
  .topTitle {
    width: 100%;
    height: 64px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: left;
    border-bottom: 1px solid #d8d8d8;
    position: sticky;
    top: 80px;
    background: #fff;
    z-index: 20;
    > div {
      width: 1049px;
      margin: 0 auto;
      > div {
        height: 64px;
        line-height: 64px;
      }
      .newsTitle {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .backBtn {
    cursor: pointer;
    line-height: 64px;
    width: 79px;
  }
  .backBtn:hover {
    color: #0035fb;
    border-bottom: 2px solid #0035fb;
  }

  .news {
    /* position: relative;
  top: 38px; */
    margin: 38px auto 0;
    width: 1048px;
    background: #fbfbfb;
    padding: 29px 76px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: #333333;
      line-height: 32px;
      text-align: center;
      font-style: normal;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #dbdbdb;
    }

    .date {
      width: fit-content;
      height: 24px;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      line-height: 24px;
      text-align: center;
      font-style: normal;
      margin: 0 auto;
    }

    .content {
      margin-top: 24px;

      h2 {
        font-weight: bold;
        font-size: 16px;
        color: #666666;
        line-height: 32px;
        text-align: justify;
        font-style: normal;
      }

      p {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 1.5;
        text-align: justify;
        margin: 15px 0px;
      }

      figcaption {
        font-weight: 400;
        font-size: 32px;
        color: #666666;
        line-height: 1.5;
        text-align: center;
      }
      img {
        max-width: 100%;
      }
      ul,
      ol {
        list-style: disc outside !important; /* ul 默认圆点 */
        padding-left: 2em;
        margin: 0.8em 0;
      }

      ol {
        list-style: decimal outside !important; /* ol 默认数字 */
      }

      li {
        display: list-item !important;
        list-style: inherit !important;
        margin: 0.5em 0;
      }
    }
    .videoBox {
      width: 100%;
      height: 590px;
      padding: 10px;
      box-sizing: border-box;
      background: #e4e7ed;
      border-radius: 8px;
      border: 1px solid #f8f8f8;
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
